<div [formGroup]="group" class="border border-gray-200 rounded-lg p-4 flex flex-col gap-4" data-cy="medical-treatment">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <p-selectbutton
      formControlName="category"
      [options]="categoryOptions"
      optionLabel="label"
      optionValue="value"
      [allowEmpty]="false"
      size="small"
    >
      <ng-template #item let-option>
        <span>{{ option.label | transloco }}</span>
      </ng-template>
    </p-selectbutton>
    @if (!readonly) {
      <p-button
        size="small"
        [text]="true"
        severity="danger"
        icon="pi pi-trash"
        [ariaLabel]="'animalMedical.dialog.removePosition' | transloco"
        (onClick)="remove.emit()"
      />
    }
  </div>

  @if (!isMedication) {
    <div class="flex flex-col gap-1">
      <span class="text-xs text-gray-500">{{ 'animalMedical.fields.types' | transloco }}</span>
      <div class="flex flex-wrap gap-2">
        @for (option of typeOptions; track option.value) {
          <button
            type="button"
            class="px-3 py-1 rounded-full border text-xs cursor-pointer transition-colors"
            [ngClass]="isTypeSelected(option.value)
              ? 'bg-[var(--p-primary-500)] border-[var(--p-primary-500)] text-white'
              : 'border-gray-300 hover:bg-gray-100'"
            [attr.aria-pressed]="isTypeSelected(option.value)"
            [disabled]="readonly"
            (click)="toggleType(option.value)"
          >
            {{ typeLabelKey(option.value) | transloco }}
            @if (option.intervalMonths) {
              <span class="opacity-70">· {{ option.intervalMonths }} {{ 'animalMedical.fields.monthsShort' | transloco }}</span>
            }
          </button>
        }
      </div>
    </div>
  }

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <p-iftalabel>
      <input pInputText id="preparation-{{ group.controls.key.value }}" formControlName="preparation" class="w-full" />
      <label for="preparation-{{ group.controls.key.value }}">{{ 'animalMedical.fields.preparation' | transloco }}</label>
    </p-iftalabel>
    <div class="flex flex-col gap-1">
      <p-iftalabel>
        <input pInputText id="batch-{{ group.controls.key.value }}" formControlName="batchNumber" class="w-full" />
        <label for="batch-{{ group.controls.key.value }}">{{ 'animalMedical.fields.batchNumber' | transloco }}</label>
      </p-iftalabel>
      @if (batchNumberRecommended) {
        <small class="text-orange-600 flex items-center gap-1">
          <i class="pi pi-exclamation-triangle text-xs"></i>{{ 'animalMedical.fields.batchNumberRabiesHint' | transloco }}
        </small>
      }
    </div>

    @if (isMedication) {
      <p-iftalabel>
        <input pInputText id="dose-{{ group.controls.key.value }}" formControlName="dose" class="w-full" />
        <label for="dose-{{ group.controls.key.value }}">{{ 'animalMedical.fields.dose' | transloco }}</label>
      </p-iftalabel>
      <p-iftalabel>
        <input pInputText id="frequency-{{ group.controls.key.value }}" formControlName="frequency" class="w-full" />
        <label for="frequency-{{ group.controls.key.value }}">{{ 'animalMedical.fields.frequency' | transloco }}</label>
      </p-iftalabel>
    }

    <div class="flex flex-col gap-1">
      <p-iftalabel>
        <p-datepicker
          formControlName="nextDueAt"
          inputId="nextDue-{{ group.controls.key.value }}"
          dateFormat="dd.mm.yy"
          [showIcon]="true"
          iconDisplay="input"
          [showClear]="true"
          appendTo="body"
          [fluid]="true"
          (onSelect)="markNextDueManual()"
          (onInput)="markNextDueManual()"
          (onClear)="markNextDueManual()"
        />
        <label for="nextDue-{{ group.controls.key.value }}">{{ 'animalMedical.fields.nextDueAt' | transloco }}</label>
      </p-iftalabel>
      @if (!group.controls.noFurtherDue.value) {
        <small class="text-gray-500">
          @if (intervalMonths) {
            {{ 'animalMedical.fields.nextDueSuggestion' | transloco: { months: intervalMonths } }}
          } @else if (selectedTypes.length) {
            {{ 'animalMedical.fields.nextDueNoInterval' | transloco }}
          }
          @if (group.controls.nextDueManual.value && intervalMonths) {
            · {{ 'animalMedical.fields.nextDueManual' | transloco }}
          }
        </small>
      }
      <div class="flex items-center gap-2">
        <p-checkbox formControlName="noFurtherDue" [binary]="true" inputId="noFurtherDue-{{ group.controls.key.value }}" />
        <label class="text-sm" for="noFurtherDue-{{ group.controls.key.value }}">{{ 'animalMedical.fields.noFurtherDue' | transloco }}</label>
      </div>
    </div>

    <p-iftalabel>
      <p-datepicker
        formControlName="validUntil"
        inputId="validUntil-{{ group.controls.key.value }}"
        dateFormat="dd.mm.yy"
        [showIcon]="true"
        iconDisplay="input"
        [showClear]="true"
        appendTo="body"
        [fluid]="true"
      />
      <label for="validUntil-{{ group.controls.key.value }}">{{ 'animalMedical.fields.validUntil' | transloco }}</label>
    </p-iftalabel>

    <p-iftalabel class="md:col-span-2">
      <textarea pTextarea id="treatmentNotes-{{ group.controls.key.value }}" formControlName="notes" rows="2" class="w-full"></textarea>
      <label for="treatmentNotes-{{ group.controls.key.value }}">{{ 'animalMedical.fields.notes' | transloco }}</label>
    </p-iftalabel>
  </div>
</div>
